import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import { Create, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, InputNumber } from "antd";
import AppTag from "components/AppTag";
import UploadMultiple from "components/UploadMultiple";
import TextEditor from "components/TextEditor";
import { PackageProps } from "../types";

const { TextArea } = Input;

interface ISelect {
  id: number;
  name: string;
}

const org_id = localStorage.getItem("org_id");

export const CreatePackage: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult, onFinish } = useForm();

  const destinationVisit = useSelect<ISelect>({
    resource: `${org_id}/destination_visits`,
    optionLabel: "name",
    optionValue: "id",
  });
  const localGuide = useSelect<ISelect>({
    resource: `${org_id}/local_guides?status=approved&`,
    optionLabel: "name",
    optionValue: "id",
  });

  const handleFinish = (values: any) => {
    const payload = {
      package: {
        ...values,
      },
    };
    onFinish(payload);
  };

  return (
    <Create title="เพิ่มแพ็คเกจ" saveButtonProps={saveButtonProps}>
      <Form {...formProps} onFinish={handleFinish} layout="vertical">
        <Form.Item
          label="ชื่อแพคเกจ"
          name={["name"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="ประเภท"
          name={["types"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          <AppTag onChange={(e) => e} />
        </Form.Item>
        <Form.Item
          label="รูปแบบ"
          name={["period"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="สถานที่ท่องเที่ยว"
          name={["destination_visit_id"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Select
            placeholder="เลือกสถานที่ท่องเที่ยว"
            {...destinationVisit.selectProps}
          />
        </Form.Item>
        <Form.Item
          label="ไกด์ท้องถิ่น"
          name={["local_guide_id"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Select placeholder="เลือกไกด์ท้องถิ่น" {...localGuide.selectProps} />
        </Form.Item>

        <Form.Item
          label="คำบรรยายสั้นๆ"
          name={["desciption"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          <TextArea rows={3} />
        </Form.Item>
        <UploadMultiple label="รูปภาพ" name={["images"]} />
        <Form.Item
          label="รายละเอียด"
          name={["content"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          {/* @ts-ignore */}
          <TextEditor />
        </Form.Item>
        <Form.Item
          label="เงื่อนไข"
          name={["conditions"]}
          rules={[
            {
              required: false,
            },
          ]}
        >
          {/* @ts-ignore */}
          <TextEditor />
        </Form.Item>
        <Form.Item
          label="ราคาแพ็คเกจ"
          name={["price"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            placeholder="ระบุราคา"
          />
        </Form.Item>
        <Form.Item
          label="ราคาก่อนลด"
          name={["price_before_discount"]}
          dependencies={["price"]}
          rules={[
            {
              required: false,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || value > getFieldValue("price")) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("ราคาก่อนลดต้องมากกว่าราคาสินค้า")
                );
              },
            }),
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            placeholder="ระบุราคา"
          />
        </Form.Item>
      </Form>
    </Create>
  );
};
